import { Stack, Typography, Box } from "@mui/material";

const Header = ({ label, title, desc }) => {
  return (
    <Stack
      data-aos="fade-up"
      alignItems={{ xs: "center", sm: "center" }}
      textAlign={{ xs: "center", sm: "center" }}
      maxWidth={660}
      mx="auto"
    >
      {label && (
        <Box
          py={1}
          px={2}
          bgcolor="accent.main"
          borderRadius={100}
          mb={2}
        >
          <Typography variant="body2" color="accent.contrastText">
            {label}
          </Typography>
        </Box>
      )}
      {title && (
        <Typography
          variant="h2"
          typography={{ xs: "h3", sm: "h2" }}
          style={{ fontWeight: 600 }}
        >
          {title}
        </Typography>
      )}
      {desc && (
        <Typography
          variant="h6"
          typography={{ xs: "body1", md: "h6" }}
          fontWeight={500}
          color="text.secondary"
          mt={{ xs: 1, md: 1 }}
          mb={0}
          width={{ xs: "90%", md: "60%" }}
          mx={"auto"}
        >
          {desc}
        </Typography>
      )}
    </Stack>
  );
};

export default Header;
